/**
 * Shared reference to the CustomRuntime singleton.
 * Used by settings sections to access the export registry, etc.
 * Set by App.tsx on startup; never null after shell boot.
 */
import type { ShellRuntime } from '../bootstrap/createRuntime';

let _runtime: ShellRuntime | null = null;

export function setRuntime(rt: ShellRuntime): void {
  _runtime = rt;
}

export const runtime: ShellRuntime = new Proxy({} as ShellRuntime, {
  get(_target, prop) {
    if (!_runtime) throw new Error('[runtimeRef] Runtime not yet initialized');
    return (_runtime as any)[prop];
  },
});
